import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " 1. Hur gör jag för att returnera en eller flera av mina biljetter? ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "/return" }, "här", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " 2. Min biljett inehåller felaktig information, vad ska jag göra? ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " 3. Jag har betalat för mina biljetter, men har inte fått någon bokningsbekräftelse. Vad gör jag? ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "1. Hur aktiverar jag mina biljetter?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " 2. Vad gör jag om min telefon med biljetterna inte är tillgänglig? ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "4. Hur fungerar barn-biljetter?", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "5. Vilka enheter har support för digitala biljetter?", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " 6. Vad gör jag om jag tappar bort min biljett eller min boknings-information? ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " 7. Kan jag flytta biljetter mellan enheter? Till exempel om min resgrupp vill dela på sig under resan? ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Fick du inte svar på din fråga?"),
  /*#__PURE__*/_createElementVNode("p", null, "Kontakta gärna vår support på kundservice@tågluffaieuropa.se")
], -1)

import CustomDisclosure from "../generics/CustomDisclosure.vue";
import CustomAccordion from "../generics/CustomAccordion.vue";
import TextBlock from "../blocks/TextBlock.vue";
import PageTitle from "../blocks/PageTitle.vue";
import ContentWrapper from "../generics/ContentWrapper.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SupportView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageTitle, {
      text: "Support",
      backgroundImageClass: "background-general-train"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, { content: "Välkommen till vår support sida. Här kan du få svar på några vanliga frågor runt bokningar och interrail kort. Om du skulle undra något som inte täcks av våran FAQ får du gärna kontakta vår support." }),
        _createVNode(CustomAccordion, { header: "Bokning" }, {
          default: _withCtx(() => [
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_1
              ]),
              body: _withCtx(() => [
                _createTextVNode(" Du kan returnera hur många biljetter du vill förutsatt att du inte har aktiverat biljetterna eller dom av någon annan anledning inte är retunerbara. För att återköpa en eller flera biljetter kan du använda vårat återköps-flöde, som går att finna "),
                _hoisted_2,
                _createTextVNode(". ")
              ]),
              _: 1
            }),
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              body: _withCtx(() => [
                _createTextVNode(" Du kan tyvärr inte modifiera informationen på din biljett själv. Kontakta vår support så ska vi göra vårat bästa för att hjälpa dig. ")
              ]),
              _: 1
            }),
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_4
              ]),
              body: _withCtx(() => [
                _createTextVNode(" Det kan finnas en viss fördröjning från det att bokningen genomförts tills dess mailet skickas ut. Om du inom 12 timmar inte fått något bekräftelsemail, kontakta då vår kundsupport så hjälper vi dig. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(CustomAccordion, { header: "Biljetter" }, {
          default: _withCtx(() => [
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_5
              ]),
              body: _withCtx(() => [
                _createTextVNode(" För att se och använda dina biljetter använder du Interrails Rail Planner app. Du aktiverar biljetterna genom att ange koden som vi skickade till dig i ditt konfirmations-mail. ")
              ]),
              _: 1
            }),
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_6
              ]),
              body: _withCtx(() => [
                _createTextVNode(" Om du på något sätt förlorat dina digitala biljetter så rekomenderar vi dig att kontakta Interrails support här. Ange där ditt bokningsnummer så kommer du få hjälp. ")
              ]),
              _: 1
            }),
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_7
              ]),
              body: _withCtx(() => [
                _createTextVNode(" En barn-biljett aktiveras i Interrails app precis som en standardbiljett. Viktigt att veta är att maximalt två barn-biljetter är tillåtna för varje vuxen-biljett. ")
              ]),
              _: 1
            }),
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_8
              ]),
              body: _withCtx(() => [
                _createTextVNode(" Interrails app är tillgänglig på både Android och Iphone. För att installera appen krävs Android version 6.0 eller senare samt IOS version 11.0 eller senare. ")
              ]),
              _: 1
            }),
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_9
              ]),
              body: _withCtx(() => [
                _createTextVNode(" All information om din bokning finns i bekräftings-mailet som vi skicka vid godkänd bokning. Om du av någon aledning inte har tillgång till mailet längre, kontakt vår support så skickar vi ett nytt. ")
              ]),
              _: 1
            }),
            _createVNode(CustomDisclosure, null, {
              header: _withCtx(() => [
                _hoisted_10
              ]),
              body: _withCtx(() => [
                _createTextVNode(" Det är inte möjligt att flytta biljetter mellan enheter efter att dom har aktiverats. Det finns dock inget krav att alla biljetter gjorda i samma bokning aktiveras på samma enhet. Om ni tror att ni kommer dela på gruppen under resans gång bör ni aktivera biljetterna på var resenärs enhet. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_11
      ]),
      _: 1
    })
  ], 64))
}
}

})